import { useCallback } from 'react';
import { patchProjectMetadata } from '../features/layout/layoutSlice';
import {
  CUSTOM_PROCESS_TYPES_METADATA_KEY,
  addCustomProcessType,
  buildProcessTypeCatalog,
} from '../features/equipment/processTypeCatalog';
import type { EquipmentProcessType } from '../features/equipment/equipmentTypes';
import { useAppDispatch, useAppSelector } from './redux';

export function useProjectProcessTypes(observedValues: readonly unknown[] = []) {
  const dispatch = useAppDispatch();
  const projectMetadata = useAppSelector((state) => state.layout.projectMetadata);
  const processTypes = buildProcessTypeCatalog(projectMetadata, observedValues);

  const addProcessType = useCallback(
    (value: string): EquipmentProcessType | null => {
      const added = addCustomProcessType(projectMetadata, value);
      if (!added) return null;
      dispatch(
        patchProjectMetadata({
          [CUSTOM_PROCESS_TYPES_METADATA_KEY]: added.customProcessTypes,
        })
      );
      return added.processType;
    },
    [dispatch, projectMetadata]
  );

  return { processTypes, addProcessType };
}
